module.exports = __webpack_public_path__ + "img/融资联合体.5908830c.png";